<fieldset>
  <legend>{{legend}}</legend>

  <mat-card appearance="outlined">
    <mat-card-actions align="end">
      @if(client===null){
      <button matButton (click)="addClient()">
        <mat-icon aria-hidden="true">person_add</mat-icon>
        Add client
      </button>
      }
      <mat-form-field>
        <mat-label>Consent Type:</mat-label>
        <mat-select [(value)]="selectedConsentType" [disabled]="!client">
          @for (type of consentTypes; track $index) {
          <mat-option [value]="type.id">{{type.name}}</mat-option>
          }
        </mat-select>

      </mat-form-field>
      <button matButton [disabled]="!client || selectedConsentType === ''" (click)="OpenConfirmDialog()">
        <mat-icon aria-hidden="true">post_add</mat-icon>
        new Consent
      </button>

    </mat-card-actions>
  </mat-card>
  @if ( client === undefined)
  {
  <mat-card class="no-data-found">
    <mat-card-content>
      -- The client's hub does not have access to this feature. --
    </mat-card-content>
  </mat-card>
  }
  @if ( client === null){
  <mat-card class="no-data-found">
    <mat-card-content>
      -- This client has not been configured to use this feature. --
    </mat-card-content>
  </mat-card>
  }
  @else{
  @if(consents){
  <mat-form-field class="filter-input">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Term to search..." #input>
  </mat-form-field>
  <div class="item-container">
    @for(item of consents; track $index){
    <mat-card class="document">
      <mat-card-header>
        <mat-card-title>{{item.name}}</mat-card-title>
        <mat-card-subtitle>Status: {{ item.status }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <hr />
        <p>
          <span aria-label="Sent date">
            <code><b>Created: </b>{{item.CreatedAt | date: 'MM/dd/yyyy hh:mm a'}}</code>
          </span>
        </p>
        <p>
          <span aria-label="Watch date">
            <code><b>Updated: </b>{{item.LastModifiedAt | date: 'MM/dd/yyyy hh:mm a'}}</code>
          </span>
        </p>
      </mat-card-content>
      <mat-card-actions align="end">
        @if( !item.signedDocumentId ){
        <a matButton="outlined" [href]="item.formRelayUrl" target="_blank"><mat-icon aria-hidden="true">check</mat-icon> Complete</a>
        }
        @else{
        <button matButton="outlined" (click)="openDocument(item.signedDocumentId)"><mat-icon aria-hidden="true">visibility</mat-icon> Open</button>
        }
      </mat-card-actions>
    </mat-card>
    }
  </div>

  @if(consents.length === 0){
  <mat-card>
    <mat-card-content>
      -- No consents found --
    </mat-card-content>
  </mat-card>
  }
  }
  }
  <mat-paginator (page)="pageChanged($event)"
                 [length]="length"
                 [pageIndex]="pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 showFirstLastButtons
                 aria-label="Select page of elements">
  </mat-paginator>
</fieldset>
